import React from 'react';
import { t } from '../../../../modules/infra/i18n';

import WaitingList from './WaitingList';

const BarberWaitingList = props => (
  <WaitingList heading={t('barber:waiting_list.barber_waiting_list_heading')} {...props} />
);

export default BarberWaitingList;
